import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-products-settings',
  templateUrl: './products-settings.component.html',
  styleUrls: ['./products-settings.component.scss']
})
export class ProductsSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
